import angular from 'angular';
import { find } from 'lodash';

export default class PlanService {
    /* @ngInject */
    constructor($q, apiService) {
        this.$q = $q;
        this.apiService = apiService;

        this.PaymentFrequency = {
            Monthly: 1,
            Yearly: 12
        };
    }

    getAll(params) {
        return this.apiService.get('/subscriptions/plans', {
            params: angular.merge({
                withPrice: true,
            }, params)
        }).then((result) => {
            if (result && result.data && result.data.length > 0) {
                return result.data;
            }

            return this.$q.reject();
        });
    }

    getAllUpgrade() {
        return this.getAll({
            upgradeOnly: true
        });
    }

    get(id) {
        return this.apiService.get(`/subscriptions/plans/${id}`, {
            params: {
                withPrice: true
            }
        }).then((result) => result.data);
    }

    getSubscriptionInfo() {
        return this.apiService.get(`/users/me/subscription-info`).then((result) => result.data);
    }

    getSubscriptionByFrequency(plan, frequency) {
        return this.getSubscription(plan, (subscription) => subscription.frequency === frequency);
    }

    getSubscriptionById(plan, id) {
        return this.getSubscription(plan, (subscription) => subscription.id === id);
    }

    hasPurchasableSubscription(plan) {
        return !!this.getSubscription(plan, (subscription) => !!subscription.iapId);
    }

    getSubscription(plan, callback) {
        let subscriptions = plan.subscriptions || [];

        return find(subscriptions, callback) || subscriptions[0] || null;
    }

    getFreeMonthsCount(plans, sourceFrequency, targetFrequency) {
        let count = plans.reduce((value, plan) => {
            let source = this.getSubscriptionByFrequency(plan, sourceFrequency);
            let target = this.getSubscriptionByFrequency(plan, targetFrequency);

            return source && target && source.price > 0 && target.price > 0
                ? Math.min(target.frequency - target.price / (source.price / source.frequency), value)
                : value;
        }, Infinity);

        return count === Infinity ? 0 : count;
    }

    getSubscriptionSaving(plan, sourceFrequency, targetFrequency) {
        let source = this.getSubscriptionByFrequency(plan, sourceFrequency);
        let target = this.getSubscriptionByFrequency(plan, targetFrequency);

        return source && target && source.price > 0 && target.price > 0
            ? Math.abs(Math.min(target.price / target.frequency - source.price / source.frequency, 0))
            : 0;
    }
}



// WEBPACK FOOTER //
// ./src/common/service/payment/plan.service.js